import { Fragment, h } from '@atomify/jsx';

export interface RangeSliderProps {
    min: number;
    max: number;
    increment: number;
    start: number[];
    onChange: (e: CustomEvent) => void;
    name: string;
    classes?: string;
    disabled?: boolean;
    enableInputControls?: boolean;
    minLabel?: Text | string;
    maxLabel?: Text | string;
    valuePrefix?: Text | string;
}

export const RangeSliderElement = ({
    classes,
    disabled,
    min,
    max,
    increment,
    start,
    name,
    onChange,
    enableInputControls,
    minLabel,
    maxLabel,
    valuePrefix,
}: RangeSliderProps) => {
    const inputClasses = {
        ['c-range-slider']: true,
        ['form__item']: true,
        ['form__item--disabled']: disabled,
    };

    return (
        <div class={inputClasses}>
            <bpd-range-slider
                min={min}
                max={max}
                increment={increment}
                start={start}
                onRangeValuesChanged={onChange}
                class={classes}>
                <div class="range-slider__container">
                    <div js-hook-slider-container></div>
                    <div class="range-slider__values">
                        {enableInputControls ? (
                            <Fragment>
                                <div class="range-slider__value-input-container">
                                    <span class="range-slider__value-input-label">{minLabel}</span>
                                    <div class="range-slider__value-input-wrapper">
                                        <span class="range-slider__value-prefix">
                                            {valuePrefix}
                                        </span>
                                        <input
                                            type="number"
                                            min={min}
                                            max={max}
                                            step={increment}
                                            class="range-slider__value-input"
                                            js-hook-slider-min
                                        />
                                    </div>
                                </div>
                                <div class="range-slider__value-input-container">
                                    <span class="range-slider__value-input-label">{maxLabel}</span>
                                    <div class="range-slider__value-input-wrapper">
                                        <span class="range-slider__value-prefix">
                                            {valuePrefix}
                                        </span>
                                        <input
                                            type="number"
                                            min={min}
                                            max={max}
                                            step={increment}
                                            class="range-slider__value-input"
                                            js-hook-slider-max
                                        />
                                    </div>
                                </div>
                                <input
                                    type="text"
                                    id={name}
                                    name={name}
                                    class="u-sr-only"
                                    js-hook-slider-min-max-value
                                />
                            </Fragment>
                        ) : (
                            <Fragment>
                                <span class="range-slider__values-item" js-hook-slider-min></span>
                                <span class="range-slider__values-item" js-hook-slider-max></span>
                                <input
                                    type="number"
                                    id={`${name}-0`}
                                    name={name}
                                    value={start[0]}
                                    js-hook-slider-min-value
                                />
                                <input
                                    type="number"
                                    id={`${name}-1`}
                                    name={name}
                                    value={start[1]}
                                    js-hook-slider-max-value
                                />
                            </Fragment>
                        )}
                    </div>
                </div>
            </bpd-range-slider>
        </div>
    );
};
